// Sprachen eines Kunden.
//
// Sprachen sind Tags vom Typ `language`: `tag_key` trägt den Sprachcode
// ("de", "en"), `tag_label` den Anzeigenamen ("Deutsch", "English"), und genau
// einer je Standort kann als Standard markiert sein (`is_default`).
//
// Übergangslösung: Am Besucher wird weiterhin das Feld `language` geführt; der
// Sprach-Tag wird zusätzlich verknüpft, bis das Feld entfällt.

const KNOWN_LABELS = { de: "Deutsch", en: "English", fr: "Français", it: "Italiano" };

/**
 * Auswählbare Sprachen für einen Standort — kundenweite plus standortgebundene,
 * standortspezifisch schlägt kundenweit.
 *
 * Angeboten wird nur, was sich auch auswirkt: Sprachen mit eigener E-Mail-
 * Vorlage (`has_email_template`) und die Standardsprache. Die Standardsprache
 * bleibt immer dabei — sie wird von der Vorlage ohne Tag bedient, sonst käme
 * man nach einem Wechsel nicht mehr zu ihr zurück.
 */
export function buildLanguageOptions(tags, locationId) {
  const eligible = (tags || [])
    .filter((t) => t.tag_type === "language" && t.tag_key)
    .filter(
      (t) =>
        t.location_id == null || String(t.location_id) === String(locationId),
    );

  const byKey = new Map();
  for (const tag of eligible) {
    const existing = byKey.get(tag.tag_key);
    if (!existing || (existing.location_id == null && tag.location_id != null)) {
      byKey.set(tag.tag_key, tag);
    }
  }

  return Array.from(byKey.values())
    .filter((tag) => tag.has_email_template || tag.is_default)
    .map((tag) => ({
      value: tag.tag_key,
      label: tag.tag_label || KNOWN_LABELS[tag.tag_key] || tag.tag_key,
      short: tag.tag_key.toUpperCase(),
      isDefault: !!tag.is_default,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, "de", { sensitivity: "base" }));
}

/** Vorauswahl: der als Standard markierte Eintrag, sonst der erste. */
export function defaultLanguage(options) {
  if (!options?.length) return null;
  return (options.find((o) => o.isDefault) || options[0]).value;
}
